/**
 * Computes a sliding window of pager-dot indices (max `maxDots`) centred on the
 * current index, so a many-item carousel shows a capped dot row whose edges can
 * shrink to hint at more. Pure — no React state.
 */
export function getDotWindow(
  currentIndex: number,
  itemCount: number,
  maxDots = 5,
): { dotStart: number; dotEnd: number; dotWindow: number[]; isEdgeDot: (i: number) => boolean } {
  const dotStart =
    itemCount <= maxDots
      ? 0
      : Math.min(Math.max(currentIndex - Math.floor(maxDots / 2), 0), itemCount - maxDots);
  const dotEnd = Math.min(dotStart + maxDots, itemCount);
  const dotWindow = Array.from({ length: dotEnd - dotStart }, (_, k) => dotStart + k);
  const isEdgeDot = (i: number) =>
    (dotStart > 0 && i === dotStart) || (dotEnd < itemCount && i === dotEnd - 1);
  return { dotStart, dotEnd, dotWindow, isEdgeDot };
}
